import "./loadingDots.css"
import {Grid} from "@mui/material";
import {BASE_PATH} from "@/components/constants";

const loading = {
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 1000
}

export default function LoadingDots() {
    return <Grid className="df jcc aic we1 he1 noSelect" sx={{...loading}}>
        <img src={`${BASE_PATH}/images/tp6.gif`} alt="" style={{width: "20rem"}} />
    </Grid>
}